export default "__VITE_ASSET__D0uClfhm__"